import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import Table from '../../../../components/Table/Table';
import { deniedUsersFetchAction } from '../../../../store/fetchActions/deniedUsersActions';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../../../components/Filter/Filter';
import TextInput from '../../../../components/TextInput/TextInput';
import DateInput from '../../../../components/DateInput/DateInput';
import Button from '../../../../components/Button/Button';
import { theme } from '../../../../styles/theme';
import { ImSearch } from 'react-icons/im';
import formatCPF from '../../../../utils/functions/formatCPF';
import formatCNPJ from '../../../../utils/functions/formatCNPJ';
import { useForm } from 'react-hook-form';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../../../components/Filter/Filter.styles';
import SelectOptions from '../../../../components/SelectOptions/SelectOptions';
import useCallFilter from '../../../../utils/hooks/useCallFilter';
import { LoadingContainer } from '../../styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';

const { rbmWhite } = theme.colors;

function UsuariosNegados(props) {
  const { value, index } = props;
  const dispatch = useDispatch();
  const [filterData, setFilterData] = useState('');
  const { handleSubmit, control, reset } = useForm({});
  const [filter, setFilter] = useState({
    SEARCH: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    LIMIT: 10,
    PAGE: 1,
  });

  const {
    deniedUsersData,
    paginationDeniedUsers,
    loadingDeniedUsers,
    errorDeniedUsers,
    messageDeniedUsers,
  } = useSelector((state) => state.deniedUsers);

  useCallFilter(filterData, setFilter, deniedUsersFetchAction, value, index);

  useEffect(() => {
    value != index && (() => setFilterData(''))();
    reset({ SEARCH: '', DATA_INICIAL: '', DATA_FINAL: '', LIMIT: 10, PAGE: 1 });
  }, [value, index]);

  useEffect(() => {
    value === index && (() => dispatch(deniedUsersFetchAction(filter)))();
  }, [dispatch, value, index, filter.PAGE]);

  const pagesOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  const header = [
    {
      id: 'data de registro',
      name: 'DATA DE REGISTRO',
      align: 'center',
    },
    { id: 'CPFCNPJ', name: 'CPF/CNPJ', align: 'left' },
    { id: 'nome', name: 'NOME', align: 'left' },
    { id: 'observação', name: 'OBSERVAÇÃO', align: 'left' },
  ];

  const body = deniedUsersData?.map((user) => {
    return {
      data: [
        { info: user.DATA_INSERT, align: 'center' },
        {
          info:
            user.CPFCNPJ?.length === 11
              ? formatCPF(user.CPFCNPJ)
              : formatCNPJ(user.CPFCNPJ),
          align: 'left',
        },
        { info: user.NOME, align: 'left' },
        { info: user.MENSAGEM, align: 'left', width: '40vw' },
      ],
    };
  });

  const filterTable = (data) => {
    setFilterData(data);
  };

  return (
    <div hidden={value !== index}>
      <Filter>
        <form onSubmit={handleSubmit(filterTable)}>
          <FirstFilterLine>
            <TextInput
              label="Nome ou CPF/CNPJ"
              name={'SEARCH'}
              width={'38.042vw'}
              margin={'0 0 0 1.369vw'}
              control={control}
            />
            <DateInput
              label="Data Inicial"
              name={'DATA_INICIAL'}
              control={control}
            />
            <DateInput
              label="Data Final"
              name={'DATA_FINAL'}
              control={control}
            />

            <Button
              backgroundColor={'#303545'}
              width="12.153vw"
              margin={'0 1.389vw 0 0'}
              hoverBGColor={'#FF557E'}
              hoverColor={rbmWhite}
              color={rbmWhite}
              type="submit"
            >
              <ImSearch className="default-svg" size={'1.181vw'} />
              <span>Buscar</span>
            </Button>
          </FirstFilterLine>

          <SecondFilterLine>
            <h5>Resultados por página</h5>
            <SelectOptions
              control={control}
              options={pagesOptions}
              name={'LIMIT'}
              margin={'0 0 0 1.875vw'}
              initialValue={10}
              initialName={10}
            />
            <h5>Total de resultados: {paginationDeniedUsers?.totalResult}</h5>
          </SecondFilterLine>
        </form>
      </Filter>
      {loadingDeniedUsers ? (
        <LoadingContainer>
          <CircularProgress size={'5vw'} color="inherit" />
        </LoadingContainer>
      ) : (
        <Table
          loading={loadingDeniedUsers}
          error={errorDeniedUsers}
          hasPagination={true}
          filter={filter}
          pagination={paginationDeniedUsers}
          setFilter={setFilter}
          errorMessage={messageDeniedUsers}
          filterTable={filterTable}
          header={header}
          body={body}
        />
      )}
    </div>
  );
}

UsuariosNegados.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default memo(UsuariosNegados);
